import { withNamespaces } from "react-i18next";
import { Col, Row, TabPane } from "reactstrap";
import Accordion from "react-bootstrap/Accordion";
import { useQueries } from "@tanstack/react-query";
import { connect } from "react-redux";
import DataProtectionDPIAService from "src/modules/data-protection/apis/DataProtectionDPIAService";
import { useParams } from "react-router-dom";
import RiskAssessmentQuestionnaire from "./components/RiskAssessmentQuestionnaire";
import ImpactAssessmentQuestionnaire from "./components/ImpactAssessmentQuestionnaire";
import { mapQuestions } from "src/modules/data-protection/helpers/questionnaire";
import {
    helpers
} from '@smartintegrity/questionnaire';

const DPIAQuestionnaires = ({
    onValidSubmit,
    reportCaseId,
    showImpactAssessment
}) => {
    const { softwareId } = useParams();

    const sectionsIds = [
        'risk_assessment',
        'data_protection_impact_assessment'
    ];

    const questionsQueries = useQueries({
        queries: sectionsIds.map((sectionId) => {
            return {
                queryKey: ['data-protection-report-dpia-questions-list', sectionId],
                queryFn: async () => {
                    const service = DataProtectionDPIAService.getInstance();

                    const response = await service.questions(sectionId, {
                        softwareId: softwareId,
                        reportCase: reportCaseId,
                    });
                    
                    const mappedQuestions = mapQuestions(response, response);

                    return {
                        mappedQuestions: helpers.makeQuestionsReadyForQuestionnaire(
                            mappedQuestions,
                            false
                        ),
                        rawQuestions: mappedQuestions,
                        mappedAnswers: helpers.makePreviousAnswersReadyForQuestionnaire(
                            mappedQuestions,
                            mappedQuestions
                        )
                    }
                },
                enabled: !!showImpactAssessment || sectionId !== "data_protection_impact_assessment",
                refetchOnWindowFocus: false
            }
        })
    });

    const risksAssessmentQuery = questionsQueries[0];
    const impactAssessmentQuery = questionsQueries[1];

    return (
        <TabPane
            tabId="dpia"
            className="pt-4"
        >
            <Row>
                <Col sm="12">
                    <div className="p-2">
                        <Accordion
                            className="smartintegrity__questionnaire__tabs_progress"
                        >
                            <RiskAssessmentQuestionnaire
                                questionsQuery={risksAssessmentQuery}
                                softwareId={softwareId}
                                onValidSubmit={onValidSubmit}
                            />

                            <ImpactAssessmentQuestionnaire
                                questionsQuery={impactAssessmentQuery}
                                softwareId={softwareId}
                                onValidSubmit={onValidSubmit}
                                showImpactAssessment={showImpactAssessment}
                            />
                        </Accordion>
                    </div>
                </Col>
            </Row>
        </TabPane>
    );
};

const mapStatetoProps = (state) => {
    const { token, user } = state.Login;

    return {
        token,
        user
    };
};

export default withNamespaces()(
    connect(mapStatetoProps)(
        DPIAQuestionnaires
    )
);
